module.exports = __webpack_public_path__ + "static/2020katahira-ad3bf717d13c86d85b17690b66137684.jpg";